export const NavLinks = [
	{ id: 1, name: 'Home', path: '/' },
	{ id: 9, name: 'Últimas Notícias', path: '/ultimas-noticias/' },
	{ id: 2, name: 'Celebridades', path: '/famosos/' },
	{ id: 3, name: 'Agora', path: '/agora/' },
	{ id: 4, name: 'Futebol', path: '/futebol/' },
	{ id: 5, name: 'Beleza', path: '/beleza/' },
	{ id: 6, name: 'INSS', path: '/inss/' },
];
